<template>
  <div>
    <!--PC-->
    <div>
      <nav-header
        ref="navHeader"
        v-bind:showSearch="p_showSearch"
        v-bind:loginModalFlag="p_loginModalFlag"
        v-on:showLoginModal="p_showLoginModal"
        v-on:closeLoginModal="p_closeLoginModal"></nav-header>
      <nav-bread>
        <span slot="cart">购物车</span>
      </nav-bread>
      <div class="container" style="margin: 36px auto 70px" v-loading="loading">
        <!-- 类型 -->
        <div class="cart mhide">
          <el-col :lg="12" :md="12" :sm="12">
            <!--<el-col :lg="12" :md="12" :sm="12" class="mhide">-->
              <!--<el-checkbox v-model="checkedAll" @change="chooseAllGoods" :disabled="cartList.length == 0">全选-->
              <!--</el-checkbox>-->
            <!--</el-col>-->
            <el-col :lg="12" :md="12" :sm="12" class="hidden-xs-only"><span class="info">商品信息</span></el-col>
          </el-col>
          <el-col :lg="12" :md="12" :sm="12" class="hidden-xs-only">
            <el-col :lg="5" :md="5" :sm="6">
              <div>单价</div>
            </el-col>
            <el-col :lg="5" :md="5" :sm="6">
              <div>规格</div>
            </el-col>
            <el-col :lg="5" :md="5" :sm="7">
              <div>数量</div>
            </el-col>
            <el-col :lg="5" :md="5" :sm="5">
              <div>金额</div>
            </el-col>
            <el-col :lg="4" :md="4" :sm="4" class="hidden-sm-and-down">
              <div style="padding-left:20px">操作</div>
            </el-col>
          </el-col>
        </div>
        <!-- 商品详细内容 -->
        <div class="com" v-for="(item,index) in cartList" :key="index">
          <div class="cart">
            <el-col :lg="12" :md="12" :sm="12">
              <el-checkbox v-model="item.comChecked" @change="chooseShopGoods(index,item)">
              </el-checkbox>
              <img src="../../static/com.png" class="com_img" alt="">
              <router-link v-if="providerId" target="_blank" :to="{path:'/company/index', query:{id:item.providerId}}" class="com_name">
                {{item.providerName}}
              </router-link>
              <span class="com_name" v-else>{{item.providerName}}</span>
            </el-col>
          </div>
          <div class="header-a" v-for="(item1,index1) in item.data" :key="index1">
            <div class="row clearfix">
              <!-- 左边 -->
              <el-col :lg="12" :md="12" :sm="12" :xs="24">
                <el-col :lg="8" :md="8" :sm="10" :xs="6" class="imgs clearfix">
                  <el-checkbox v-model="item1.checked" @change="choose(index,index1)"
                               :disabled="item1.specStatus == 0"></el-checkbox>
                  <span><img class="goods_img" :src="item1.img" :alt="'检验网' + item1.itemName"></span>
                </el-col>
                <el-col :lg="12" :md="12" :sm="12" :xs="18" class="main">
                  <ul class="titel">
                    <li>
                      <router-link target="_blank" :to="{path:'/detection', query:{id:item1.id}}">{{item1.itemName}}
                      </router-link>
                    </li>
                  </ul>
                </el-col>
                <el-col :lg="12" :md="12" :sm="12" :xs="18" class="map">
                  <el-tag type="primary" class="please" v-show="item1.type===3">服务类商品请统一下单</el-tag>
                  <!-- <div class="please" v-show="item1.type===3">服务类商品请统一下单</div> -->
                </el-col>
              </el-col>
              <!-- 右边 -->
              <el-col :lg="12" :md="12" :sm="12" :xs="24">
                <el-col :lg="5" :md="5" :sm="5" :xs="24" class="mhide">￥{{item1.specPrice | FormatCurrency(item1.specPrice)}}</el-col>
                <el-col :lg="4" :md="4" :sm="5" :xs="24" class="mhide">{{item1.itemSpecList[0].spec}}</el-col>
                <el-col :lg="6" :md="6" :sm="9" class="price">
                  <span>
                    <a href="javascript:;" :class="item1.number == 1 ? 'dis' : ''"
                       @click="numChange(index,index1,-1,item1)">-</a>
                  </span>
                  <input type="number" :value="item1.number" class="num" v-enter-number
                         @change="numEntry(index,index1,item1,$event)" @blur="numBlur(index,index1,item1,$event)">
                  <span>
                    <a href="javascript:;" :class="item1.number == 9999 ? 'dis' : ''"
                       @click="numChange(index,index1,1,item1)">+</a>
                  </span>
                </el-col>
                <el-col :lg="6" :md="6" :sm="5" class="money">￥{{item1.specPrice * item1.number |
                  FormatCurrency(item1.specPrice * item1.number )}}
                </el-col>
                <el-col :lg="3" :md="3" :sm="3" class="mhide main">
                  <ul class="del">
                    <li style="text-align: left"><a href="javascript:;" @click="delGoods(index,index1,item1.id+'_'+item1.itemSpecList[0].id)">删除</a>
                    </li>
                  </ul>
                </el-col>
              </el-col>
            </div>
          </div>

        </div>
        <div class="com_empty clearfix" v-if="!loading && cartList.length == 0">
          <!--<img src="./../../static/empty.png" alt="" class="empty_img ">-->
          <div class="empty_text">当前没有可下单商品,快去添加吧</div>
        </div>

        <!-- 规格被删除的商品 -->
        <div class="com" v-for="(item3,index3) in delSpecList" :key="index3">
          <div class="cart">
            <el-col :lg="12" :md="12" :sm="12">
              <el-checkbox v-model="item3.comChecked" @change="chooseShopGoods(index3,item3)" disabled>
              </el-checkbox>
              <img src="../../static/com.png" class="com_img" alt="">
              <router-link v-if="providerId" target="_blank" :to="{path:'/company/index', query:{id:item3.providerId}}" class="com_name">
                {{item3.providerName}}
              </router-link>
              <span class="com_name" v-else>{{item3.providerName}}</span>
            </el-col>
          </div>
          <div class="header-a" v-for="(item4,index4) in item3.data" :key="index4">
            <div class="row clearfix" style="background-color:#f0f0f0;">
              <!-- 左边 -->
              <el-col :lg="12" :md="12" :sm="12" :xs="24">
                <el-col :lg="8" :md="8" :sm="10" :xs="6" class="imgs clearfix">
                  <el-checkbox disabled class="mhide"></el-checkbox>
                  <span><img class="goods_img" :src="item4.img" :alt="'检验网' + item4.itemName"></span>
                </el-col>
                <el-col :lg="12" :md="12" :sm="12" :xs="18" class="main">
                  <ul class="titel">
                    <li>
                      <div v-if="item4.status != 1" style="color:#ccc">{{item4.itemName}}
                        <el-tag type="info" v-if="item4.status == 0">未发布</el-tag>
                        <el-tag type="info" v-else="item4.status == 2">已下架</el-tag>
                      </div>
                      <router-link target="_blank" v-else :to="{path:'/detection', query:{id:item4.id}}"
                                   style="color:#ccc">{{item4.itemName}}
                        <el-tag type="info">该规格失效</el-tag>
                      </router-link>
                    </li>
                  </ul>
                </el-col>
              </el-col>
              <!-- 右边 -->
              <el-col :lg="12" :md="12" :sm="12" :xs="24"  class="jine">
                <el-col :lg="5" :md="5" :sm="5" :xs="24" class="mhide" style="color:#ccc">￥{{item4.specPrice |
                  FormatCurrency(item4.specPrice)}}
                </el-col>
                <el-col :lg="4" :md="4" :sm="5" :xs="24"  class="mhide" style="color:#ccc"
                        :style="item4.status == 1 && item4.specStatus == 0 ? 'text-decoration: line-through' : '' ">
                  {{item4.itemSpecList[0].spec}}
                </el-col>
                <el-col :lg="6" :md="6" :sm="9" class="price mhide" style="color:#ccc">{{item4.number}}
                  <!--<span>-->
                  <!--<a href="javascript:;" :class="item1.number == 1 ? 'dis' : ''"-->
                  <!--@click="numChange(index,index1,-1,item1)">-</a>-->
                  <!--</span>-->
                  <!--<input type="number" :value="item1.number" class="num" v-enter-number-->
                  <!--@change="numEntry(index,index1,item1)" @blur="numBlur(index,index1,item1)">-->
                  <!--<span>-->
                  <!--<a href="javascript:;" :class="item1.number == 9999 ? 'dis' : ''"-->
                  <!--@click="numChange(index,index1,1,item1)">+</a>-->
                  <!--</span>-->
                </el-col>
                <el-col :lg="6" :md="6" :sm="5" class="money mhide" style="color:#ccc">￥{{item4.specPrice * item4.number |
                  FormatCurrency(item4.specPrice * item4.number)}}
                </el-col>
                <el-col :lg="3" :md="3" :sm="3" class=" main">
                  <ul class="dell">
                    <li style="text-align: left"><a herf="javascript:;"
                                                    @click="delSpecGoods(index3,index4,item4.id+'_'+item4.itemSpecList[0].id)">删除</a>
                    </li>
                  </ul>
                </el-col>
              </el-col>
            </div>
          </div>

        </div>

        <!--底部结算-->
        <div class="cart_footer">
          <el-col :lg="12" :md="12" :sm="8">
            <el-col :lg="12" :md="12" :sm="12" :offset="1">
              <el-checkbox v-model="checkedAll" @change="chooseAllGoods" :disabled="cartList.length == 0">全选
              </el-checkbox>
              <span v-if="cartList.length != 0">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
              <a herf="javascript:;" @click="delMoreGoods" v-if="cartList.length != 0">批量删除</a>
            </el-col>


          </el-col>
          <el-col :lg="12" :md="12" :sm="16" class="footer-right">
            <el-col :lg="9" :md="9" :sm="7" class="zog">
              <span>已选商品 <span class="goods_number">{{totalNumber}}</span> 件</span>
            </el-col>
            <el-col :lg="9" :md="9" :sm="9" class="heji">
              <span>合计 <span class="goods_number">￥{{totalMoney | FormatCurrency(totalMoney)}}</span>
                <!--线上金额：线下金额：-->
              </span>
            </el-col>
            <el-col :lg="6" :md="6" :sm="6">
              <el-button class="btn" type="primary" style="color: #ffffff"
                         v-if="user.isChannel == 2 || user.isChannel == 1" @click="order">下单
              </el-button>
              <el-button class="btn" type="primary" style="color: #ffffff" v-else @click="order">结算</el-button>
            </el-col>
          </el-col>
        </div>

      </div>
      <!--<nav-footer></nav-footer>-->
    </div>

    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import {getCookie, removeHTMLTag} from "../util/util";

  export default {
    name: "cart",
    data() {
      return {
        advertiseList: [],
        selected: "Cart",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_Filled.png"),
          require("@/assets/me_grey.png")
        ],
        p_showSearch: true,
        p_loginModalFlag: false,
        checkedAll: false,
        cartList: [],
        itemList: [],
        totalMoney: 0,
        totalNumber: 0,
        loading: true,
        delSpecList: [],
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      }
    },
    components: {
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread
    },
    mounted: function () {
      if (getCookie("_token")) {
        this.getCartList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      //跳转到详情页
      todetection(id) {
        this.$router.push({path: "detection", query: {id: id}})
      },
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      getCartList() {
        axios.get("/jys/cart?shopId=" + this.providerId, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token"),
            "pcKey": getCookie("pc"),
          }
        }).then((response) => {

          let res = response.data
          if (res.code == 0) {
            this.loading = false
            if (res.itemList != null) {
              //有效的商品数组
              let itemList = res.itemList.filter((item, index, arr) => {
                return item.specStatus == 1 && item.status == 1
              })

              //规格被删除的数组
              let delSpecList = res.itemList.filter((item, index, arr) => {
                return item.status == 1 && item.specStatus == 0
              })

              // 失效的商品数组
              let invalidList = res.itemList.filter((item, index, arr) => {
                return item.status != 1
              })
              // console.log(invalidList)
              // console.log(delSpecList.concat(invalidList));
              this.itemList = itemList
              this.cartList = this.mapArr(itemList)
              this.delSpecList = this.mapArr(delSpecList.concat(invalidList))
              // console.log(this.cartList)

            } else {
              this.cartList = []
            }
            this.$set(this.cartList)

          }
        })
      },

      //map对象改造数组
      mapArr(arr) {
        let map = {},
          dest = [];
        for (var i = 0; i < arr.length; i++) {
          var ai = arr[i];
          if (!map[ai.providerId]) {
            dest.push({
              providerId: ai.providerId,
              providerName: ai.providerName,
              data: [ai],
              comChecked: false
            });
            map[ai.providerId] = ai;
          } else {
            for (var j = 0; j < dest.length; j++) {
              var dj = dest[j];
              if (dj.providerId == ai.providerId) {
                dj.data.push(ai);
                break;
              }
            }
          }
        }
        return dest
      },

      //修改购物车信息
      editCartInfo(itemId, number, checked, itemSpecId) {
        console.log("editCartInfo")
        axios.put("/jys/cart?shopId=" + this.providerId, {
          itemId: itemId,
          number: number,
          checked: checked,
          itemSpecId: itemSpecId
        }, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token"),
            "pcKey": getCookie("pc"),
          },
        }).then((response) => {
          if (response.data.code == 0) {
            console.log("修改成功")
            this.$refs.navHeader.getCartCount();
            // this.getCartList()
          }
        })
      },


      // 全部商品全选
      chooseAllGoods: function (e) {
        console.log(e);
        for (var i = 0, len = this.cartList.length; i < len; i++) {
          this.cartList[i].comChecked = e;
          var list = this.cartList[i].data;
          for (var k = 0, len1 = list.length; k < len1; k++) {
            list[k].checked = e;
          }
        }
        this.checkedAll = e;
        this.calTotalMoney();
        this.calTotalNumber();
      },

      // 每个店铺全选
      chooseShopGoods: function (index, item) {
        this.cartList[index].comChecked = !this.cartList[index].comChecked;

        var list = this.cartList[index].data,
          len = list.length;

        if (this.cartList[index].comChecked) {
          this.cartList[index].comChecked = false
          for (var i = 0; i < len; i++) {
            list[i].checked = false;
          }
        } else {
          this.cartList[index].comChecked = true
          for (var i = 0; i < len; i++) {
            list[i].checked = true;
          }
        }

        // 判断是否选择所有商品的全选
        this.isChooseAll();

        this.cal(index);
      },

      // 单个选择
      choose: function (index, index1) {
        this.cartList[index].data[index1]['checked'] = !this.cartList[index].data[index1]['checked']

        var list = this.cartList[index].data,
          len = list.length;
        if (list[index1]['checked']) {
          this.cartList[index]['comChecked'] = false;
          this.checkedAll = false;
          list[index1]['checked'] = !list[index1]['checked'];
        } else {
          list[index1]['checked'] = !list[index1]['checked'];

          // 判断是否选择当前店铺的全选
          var flag = true;
          for (var i = 0; i < len; i++) {
            if (list[i]['checked'] == false) {
              flag = false;
              break;
            }
          }
          flag == true ? this.cartList[index]['comChecked'] = true : this.cartList[index]['comChecked'] = false;
        }

        // 判断是否选择所有商品的全选
        this.isChooseAll();
        // console.log(this.cartList[index].data[index1]['checked'])

        this.cal(index);
      },

      // 判断是否选择所有商品的全选
      isChooseAll: function () {
        var flag1 = true;
        for (var i = 0, len = this.cartList.length; i < len; i++) {
          if (this.cartList[i]['comChecked'] == false) {
            flag1 = false;
            break;
          }
        }
        flag1 == true ? this.checkedAll = true : this.checkedAll = false;
      },

      // 商品数量控制
      numChange: function (index1, index, numChange, item) {
        var goods = this.cartList[index1].data[index],
          oThis = this;
        console.log(goods)

        if (numChange == 1) {
          goods.number++;
        } else if (numChange == -1) {
          goods.number--;
        }

        if (goods.number < 1) {
          goods.number = 1;
        } else if (goods.number > 9999) {
          goods.number = 9999;
        } else {
          this.editCartInfo(item.id, goods.number, false, goods.itemSpecList[0].id)

        }
        this.cal(index1);
      },

      // 用户填写容错处理
      numEntry: function (index1, index, item, event) {
        let e = window.event || event;
        let number = e.target.value,
          goods = this.cartList[index1].data[index];
        if (number == 0) {
          goods.number = 1;
        } else if (number > 9999) {
          goods.number = 9999;
        } else {
          goods.number = number;
        }
        this.$set(this.cartList);
        this.editCartInfo(item.id, goods.number, false, goods.itemSpecList[0].id);
        this.cal(index1);

      },

      //输入框失焦点
      numBlur: function (index1, index, item, event) {
        let e = window.event || event;
        let value = e.target.value;

        if (value.length == 0) {
          console.log(value.length);
          event.target.value = 1;
          this.cartList[index1].data[index].number = 1;

          this.$set(this.cartList[index1].data[index], "number", 1);
        }
      },

      // 计算每个店铺的商品总额
      calEveryStore: function (index) {
        var everyStoreMoney = 0,
          list = this.cartList[index].data;
        list.forEach(function (item, index, arr) {
          if (list[index]['checked']) {
            everyStoreMoney += parseFloat(item.price) * parseFloat(item.number);
          }
        });
        return everyStoreMoney.toFixed(2);
      },


      // 计算商品总金额
      calTotalMoney: function () {
        var oThis = this;
        this.totalMoney = 0;
        for (var i = 0, len = this.cartList.length; i < len; i++) {
          var list = this.cartList[i].data;
          list.forEach(function (item, index, arr) {
            if (list[index]['checked']) {
              oThis.totalMoney += parseFloat(item.specPrice) * parseFloat(item.number);
            }
          });
        }
      },

      // 计算商品总数量
      calTotalNumber: function () {
        var oThis = this;
        this.totalNumber = 0;
        for (var i = 0, len = this.cartList.length; i < len; i++) {
          var list = this.cartList[i].data;
          list.forEach(function (item, index, arr) {
            if (list[index]['checked']) {
              oThis.totalNumber += parseFloat(item.number);
            }
          });
        }
      },

      // 计算方法集合
      cal: function (index) {
        this.calEveryStore(index);

        this.calTotalMoney();
        this.calTotalNumber();

      },

      // 删除操作
      delGoods: function (index1, index, id) {
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete("/jys/cart/" + id + "?shopId=" + this.providerId, {
            headers: {
              "Content-Type": "application/json",
              'token': getCookie("_token"),
              "pcKey": getCookie("pc"),
            },
          }).then((response) => {
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              //更新购物车角标
              this.$refs.navHeader.getCartCount()

              // 判断是否选择当前店铺的全选
              let thisList = this.cartList[index1].data ? this.cartList[index1].data : [];
              var flag = true;
              for (var j = 0; j < thisList.length; j++) {
                if (thisList[j].checked == false) {
                  flag = false;
                  break;
                }
              }
              flag == true ? this.cartList[index1]['comChecked'] = true : this.cartList[index1]['comChecked'] = false;
              this.$set(this.cartList);

              //判断所有商品是否全选
              this.isChooseAll();

              this.cartList[index1]['data'].splice(index, 1);
              this.cal(index1);

              //如果该检验所没有商品，删除该检验所这个对象
              for (var i = 0; i < this.cartList.length; i++) {
                let list = this.cartList[i].data
                if (list.length == 0) {
                  this.cartList.splice(i, 1)
                }
              }
              // console.log(this.cartList)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      delSpecGoods(index1, index, id) {
        // console.log(index1);
        // console.log(index);
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.delete("/jys/cart/" + id + "?shopId=" + this.providerId, {
            headers: {
              "Content-Type": "application/json",
              'token': getCookie("_token"),
              "pcKey": getCookie("pc"),
            },
          }).then((response) => {
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              //更新购物车角标
              this.$refs.navHeader.getCartCount();

              // 判断是否选择当前店铺的全选
              let thisList = this.delSpecList[index1].data ? this.delSpecList[index1].data : [];
              var flag = true;
              for (var j = 0; j < thisList.length; j++) {
                if (thisList[j].checked == false) {
                  flag = false;
                  break;
                }
              }
              flag == true ? this.delSpecList[index1]['comChecked'] = true : this.delSpecList[index1]['comChecked'] = false;
              console.log(flag);


              //判断所有商品是否全选
              this.isChooseAll()

              this.delSpecList[index1]['data'].splice(index, 1);
              // this.cal(index1);

              //如果该检验所没有商品，删除该检验所这个对象
              // console.log("如果该检验所没有商品，删除该检验所这个对象")
              // console.log(this.delSpecList)
              for (var i = 0; i < this.delSpecList.length; i++) {
                let list = this.delSpecList[i].data
                if (list.length === 0) {
                  this.delSpecList.splice(i, 1)
                }
              }
              this.$set(this.delSpecList)

              // console.log(this.cartList)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //批量删除
      delMoreGoods() {
        let checkedIdList = [];
        for (let i = 0; i < this.cartList.length; i++) {
          for (let j = 0; j < this.cartList[i].data.length; j++) {
            if (this.cartList[i].data[j].checked === true) {
              checkedIdList.push(this.cartList[i].data[j].id + '_' + this.cartList[i].data[j].itemSpecList[0].id)
            }
          }
        }
        let checkedId = JSON.stringify(checkedIdList);

        if (checkedIdList.length === 0) {
          this.$message({
            type: 'error',
            message: '请选择要删除的商品!'
          });
        } else {
          this.$confirm('此操作将永久删除这些商品, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            axios.delete("/jys/cart?shopId=" + this.providerId, {
              data: checkedId,
              headers: {
                "Content-Type": "application/json",
                'token': getCookie("_token"),
                "pcKey": getCookie("pc"),
              }
            }).then((response) => {
              if (response.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getCartList();
                this.totalNumber = 0;
                this.totalMoney = 0;
                this.$refs.navHeader.getCartCount()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }

      },

      //点击下单
      order() {
        // console.log(this.cartList)
        let checkedList = [];
        for (var i = 0; i < this.cartList.length; i++) {
          for (var j = 0; j < this.cartList[i].data.length; j++) {
            let list = this.cartList[i].data[j]
            if (list.checked == true) {
              checkedList.push(list)
            }
          }
        }
        // console.log(checkedList)
        let types = [];
        for (var i = 0; i < checkedList.length; i++) {
          let lis = checkedList[i].type
          types.push(lis)
        }
         console.log(types)
        if (checkedList.length == 0) {
          this.$message({
            type: 'error',
            message: '请选择要下单商品!'
          })
        }else if (types.some(function(value, index, types){return value === 3}) && !types.every(function(value, index, types){return value === 3})){
           this.$message({
            type: 'error',
            message: '请分开下单!'
          })
        }else {
          //下单的商品信息
          this.$store.commit("updateCheckedGoodsList", checkedList);
          this.$router.push({
            path: "/address",
            query: {
              // 'checkedList': JSON.stringify(checkedList),
              'totalMoney': this.totalMoney,
              'fromCart': true,
            }
          })
        }

      }
    }
  }
</script>

<style scoped>
  .cart {
    margin: 0 10px;
    height: 20px;
    line-height: 20px;
    position: relative;

  }
   .mshow{
     display: none;}
  .cart .com_img {
    margin: 0;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 36px;
  }

  .header-a {
    /*border-top: 1px solid #ccc;*/
    /*padding: 0 25px;*/
    width: 100%;
  }

  .header-a:last-child {
    border-bottom: 1px solid #DDDDDD;
  }

  .com {
    padding: 15px 0 30px;
  }

  .com_empty {
    width: 100%;
  }

  .com_empty .empty_text {
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
    font-size: 16px;
  }

  .row {
    width: 100%;
    /*height: 140px;*/
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background: #FCFCFC;
    border-left: 1px solid #DDDDDD;
    border-top: 1px solid #DDDDDD;
    border-right: 1px solid #DDDDDD;
  }

  label {
    float: left;
  }

  img {
    float: left;
    /*margin: 5px;*/
  }

  .goods_img {
    width: 100px;
    height: 100px;
    margin-left: 20px;
  }

  .goods_number {
    font-size: 16px;
    color: #DA434A;
  }

  .money {
    font-family: HiraginoSansGB-W3;
    font-size: 14px;
    color: #DA434A;
  }

  .price input {
    width: 48px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    border: none;
    float: left;
    margin: 0 2px;
    background-color: #fcfcfc;
  }

  .price span a {
    display: block;
    width: 27px;
    height: 27px;
    line-height: 25px;
    border: 1px solid #ccc;
    background: #fff;
    float: left;
    text-align: center;
    color: #000;
  }

  .price span a.dis {
    color: #C6C6C6;
    background: #f5f7fa;
  }

  .all {
    padding-left: 5px;
  }

  .info {
    padding-left: 40px;
  }

  .infoa {
    padding-left: 16px;
  }

  .main {
    /*text-align: center;*/
    align-items: center;
    display: flex;
  }
  .map {
    text-align: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .map .please {
      text-align: left;
      /*position: absolute;*/
      /* left: 0; */
      left: 97px;
      /* height: 40px; */
      /* top:60px; */
      top: -20px;
      font-size: 14px;
      overflow: hidden;
      /* color: #DA434A; */
    }

  .imgas p {
    margin-left: 69px;
    color: #9c9c9c;
  }

  .cart img {
    margin: 33px 10px 0px 0px;
  }

  .cart_footer {
    position: fixed;
    bottom: 10px;
    width: calc(70% - 20px);
    height: 62px;
    line-height: 62px;
    z-index:1002;
    background-color: #F5F5F5;
    box-shadow: 0 0 1px 1px rgba(153, 153, 153, 0.1);
  }

  .footer-right {
    position: relative;
    text-align: right;
  }

  .footer-right .btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 102px;
    height: 62px;
    border: none;
    font-size: 20px;
    border-radius: 0;
  }

  .com_name {
    margin-left: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
  }

  .el-loading-mask {
    opacity: 0
  }

  .price input {
    padding: 0;
  }
  .container {
    width: 70%;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .row {
      position: relative;
      padding: 10px 10px 10px 5px;
      height: 150px;
    }
    /deep/ .navbar{
      display: none;
    }
    .mshow{
      display: block;}
    .com {
      padding: 15px 0 10px;
    }

    .mhide {
      display: none;
    }

    .main ul.titel {
      text-align: left;
      position: absolute;
      left: 135px;
      height: 40px;
      top: 20px;
      font-size: 14px;
      overflow: hidden;
    }
    .main ul.del {
      position: absolute;
      right: 14px;
      top:66px;
    }
    .main ul.dell {
      position: absolute;
      right: -80px;
      top:15px;
      width: 40px;
    }
    .map {
    text-align: center;
    align-items: center;
    display: flex;
  }
  .map .please {
    text-align: left;
    position: absolute;
    left: 88px;
    width: 130%;
    /* height: 40px; */
    top: -12px;
    font-size: 14px;
    overflow: hidden;
    /* color: #DA434A; */
    }

.el-tag--small {
    height: 20px;
    padding: 0 8px;
    line-height: 20px;
}
    /deep/ .footer {
      margin-top: 242px;
    }

    .cart_footer {
      display: flex;
      flex-flow: nowrap;
      position: fixed;
      background-color: #fff;
      font-size: 12px;
      left: 10px;
      right: 0;
      width: 95%;
      bottom: 55px;
    }
    .el-checkbox {
      z-index: 0;
    }
    .cart_footer > div {
      float: left;
    }

    .footer-right .btn {
      top: 10px;
      width: 67px;
      font-size: 16px;
      height: 38px;
      line-height: 30px;
      border-radius: 5px;
    }

    /deep/ .more {
      display: none;
    }

    /deep/ .license {
      margin-top: 220px;
    }

    /deep/ .el-loading-mask {
      position: fixed;
      top: 115px;
    }

    /deep/ .el-loading-mask {
      z-index: 1991;
    }

    /deep/ .el-dialog {
      width: 98% !important;
    }

    /deep/ .md-overlay {
      z-index: 2000;
    }

    .container {
      width: 95%;margin: 0 auto 180px!important;
    }

    .cart {
      margin: 0 10px;
      height: 30px;
      line-height: 30px;
    }

    .cart .com_img {
      top: 6px;
      left: 25px;
    }

    .goods_img {
      position: absolute;
      left: 30px;
      top: 20px;
      margin-left: 0;
    }

    .spname {
      position: absolute;
      top: 50px;
    }

    .jine {
      position: absolute;
      top: 80px;
    }

    .price {
      position: absolute;
      top: 98px;
      right: 2px;
      width: 110px;
    }
.price span a{
  width: 22px;
  height: 22px;
  line-height: 19px;
    }
    .money {
      position: absolute;
      top: 102px;
      text-align: left;
      left: 135px;
      /* width: 110px; */
      width: 40px;
    }

    .el-col-xs-24 {
      width: 49%;
      text-align: right;
    }

    .com_name {
      width: 80%;
      display: inline-block;
    }
    .heji{
      position: absolute;
      top: -30px;
      right: 0;
      background-color: #f5f5f5;
      left: 0;
      padding: 0 10px;
      line-height: 30px;
    }
    .zog{
      position: absolute;
      right: 70px;
      top: -2px;
      width: initial;
    }
    .footer-right {
      position: static;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Cart.vue